export const convertAorAn = (val) => {
  return /^[aeiou]/i.test(val) ? 'an' : 'a';
}